import React from 'react';
import { Stack, Box } from '@mui/material';
import { Schedule } from 'store/schedules/interfaces';
import { wholeDayInSeconds } from 'helpers/timeConsts';
import generateScheduleWorkingDays from './generateScheduleWorkingDays';
import getDayTheme from './getDayTheme';

interface ScheduleWorkingDaysProps {
  schedule: Schedule;
  primary?: boolean;
}

export default function ScheduleWorkingDays({
  schedule,
  primary = false,
}: ScheduleWorkingDaysProps) {
  const scheduleWorkingDays = generateScheduleWorkingDays(schedule);

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      {scheduleWorkingDays.map((scheduleWorkingDay) => {
        const theme = getDayTheme({ scheduleWorkingDay, primary });
        return (
          <Box
            key={scheduleWorkingDay.day}
            sx={{
              width: '1.6rem',
              height: '5.6rem',
              border: '0.1rem solid',
              borderColor: theme.wrapper.borderColor,
              borderRadius: '0.45rem',
              background: theme.wrapper.background,
              backgroundSize: '1rem 1rem',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            {scheduleWorkingDay.ranges.map((range) => (
              <Box
                key={range.id}
                sx={{
                  position: 'absolute',
                  top: `${(range.timeFrom / wholeDayInSeconds) * 5.6}rem`,
                  left: 0,
                  width: '100%',
                  height: `${
                    ((range.timeTo - range.timeFrom) / wholeDayInSeconds) * 5.6
                  }rem`,
                  backgroundColor: theme.range.backgroundColor,
                  borderRadius: '0.45rem',
                }}
              />
            ))}
          </Box>
        );
      })}
    </Stack>
  );
}
